import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";

import BannerTable from "./modules/admin/pages/cms/banners/list";
import BannerAdd from "./modules/admin/pages/cms/banners/add";
import BannerEdit from "./modules/admin/pages/cms/banners/edit";
import BannerView from "./modules/admin/pages/cms/banners/view";
import UsersTable from "./modules/admin/pages/usermgmt/list";
import UsersView from "./modules/admin/pages/usermgmt/view";
import UsersAdd from "./modules/admin/pages/usermgmt/add";
import UserEdit from "./modules/admin/pages/usermgmt/edit";

import TestimonialTable from "./modules/admin/pages/testimonial/list";
import TestimonialAdd from "./modules/admin/pages/testimonial/add";
import TestimonialView from "./modules/admin/pages/testimonial/view";
import TestimonialEdit from "./modules/admin/pages/testimonial/edit";
import EnrollRestaurant from "./modules/admin/pages/usermgmt/enroll";
import InquiryTable from "./modules/admin/pages/inquiry/list";
import ViewInquiry from "./modules/admin/pages/inquiry/view";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import RestaurantView from "./modules/admin/pages/usermgmt/restaurantView";
import TransactionsTable from "./modules/admin/pages/usermgmt/transactionDetails";
import RenewEnrollPlan from "./modules/admin/pages/usermgmt/renewEnrollPlan";
import EditEnrollDetails from "./modules/admin/pages/usermgmt/editEnrollDetails";
import ViewEnrollDetails from "./modules/admin/pages/usermgmt/viewEnrollDetails";
import ViewTransaction from "./modules/admin/pages/usermgmt/viewTransaction";
import ViewEnrollments from "./modules/admin/pages/usermgmt/viewEnroll";
import WebsiteLayout from "./modules/website/shared/layout";
import WebsiteHomePage from "./modules/website/pages/homePage";
import Faq from "./modules/website/pages/Faq";
import Page404 from "./modules/website/pages/Page404";
import GlobalLayout from "./modules/GlobalLayout";
import ContactUsTable from "./modules/admin/pages/contactUs/list";



/** ----------------- restaurant --------------- */

import RestaurantAuthLayout from "./modules/restaurant/shared/restaurantAuthLayout";
import RestaurantPrivateRoute from "./modules/restaurant/shared/restaurantPrivateRoute";
import RestaurantLayout from "./modules/restaurant/shared/restaurantLayout";
import SelectUser from "./modules/restaurant/pages/auth/selectUser";
import RestaurantLogin from "./modules/restaurant/pages/auth/login";
import RestaurantForgotPwdPage from "./modules/restaurant/pages/auth/forgot_password";
import RestaurantResetPassword from "./modules/restaurant/pages/auth/resetPassword";
import RestaurantMyProfileLayout from "./modules/restaurant/pages/profile/shared/restaurantMyProfileLayout";
import RestMyProfile from "./modules/restaurant/pages/profile/pages/RestMyProfile";
import RestaurantHomeLayout from "./modules/restaurant/pages/dashboard/shared/restauranHomeLayout";
import RestDashboard from "./modules/restaurant/pages/dashboard/pages/RestDashboard";
import ProfileChangePassword from "./modules/restaurant/pages/profile/pages/ProfileChangePassword";
import RestaurantProfile from "./modules/restaurant/pages/profile/pages/RestaurantProfile";
import ContractInformation from "./modules/restaurant/pages/profile/pages/ContractInformation";
import MailNotificationSettings from "./modules/restaurant/pages/profile/pages/MailNotificationSettings";
import RestaurantPublicRoute from "./modules/restaurant/shared/publicRoute";
import Verifyotp from "./modules/restaurant/pages/auth/verifyotp";
import RestaurantSettingsLayout from "./modules/restaurant/pages/settings/shared/restaurantSettingsLayout"
import Staff from "./modules/restaurant/pages/settings/pages/Staff";
import Driver from "./modules/restaurant/pages/settings/pages/driver";

import QrOrderLayout from "./modules/qrOrder/shared/qrLayout";
import AddMenu from "./modules/qrOrder/pages/addMenu";
import ReviewOrder from "./modules/qrOrder/pages/reviewOrder";
import PlaceOrder from "./modules/qrOrder/pages/placeOrder";
import OrderSuccess from "./modules/qrOrder/pages/orderSuccess";
import WebsiteTerms from "./modules/website/pages/terms";
import WebsitePrivacyPolicy from "./modules/website/pages/privacyPolicy";
import WebsiteContactUs from "./modules/website/pages/contactUs";
import WebsiteAboutUs from "./modules/website/pages/aboutUs";
import WebsiteInquiry from "./modules/website/pages/inquiry";
import ViewContactUs from "./modules/admin/pages/contactUs/view";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";
import FAQView from "./modules/admin/pages/cms/faq/view";
import StaffPrivateRoute from "./modules/staff/shared/staffPrivateRoute";
import StaffHomeLayout from "./modules/staff/pages/dashboard/shared/staffHomeLayout";
import StaffDashboard from "./modules/staff/pages/dashboard/pages/staffPageDashboard";
import StaffLayout from "./modules/staff/shared/staffLayout";
import StaffPageDashboard from "./modules/staff/pages/dashboard/pages/staffPageDashboard";
import RestaurantMenuLayout from "./modules/restaurant/pages/menu/shared/restaurantMenuLayout";
import CategoriesListing from "./modules/restaurant/pages/menu/pages/CategoriesListing";
import DynamicWebPage from "./modules/website/common/dynamicPage";
import Coupon from "./modules/restaurant/pages/settings/pages/Coupon";
import ThemeCustomizer from "./modules/restaurant/pages/settings/pages/ThemeCustomizer";
import RestaurantSalesLayout from "./modules/restaurant/pages/sales/shared/restaurantMyProfileLayout";
import SalesTransactionHistory from "./modules/restaurant/pages/sales/pages/SalesTransactionHistory";
import MenuItemListing from "./modules/restaurant/pages/menu/pages/MenuItemListing";
import RestaurantTableManagementLayout from "./modules/restaurant/pages/tableManagement/shared/restaurantTableManagementLayout";
import Tables from "./modules/restaurant/pages/tableManagement/pages/Tables";
import Tip from "./modules/restaurant/pages/settings/pages/Tip";
import TipConfiguration from "./modules/restaurant/pages/settings/pages/TipConfiguration";
import Tax from "./modules/restaurant/pages/settings/pages/tax";
import DownloadReport from "./modules/restaurant/pages/settings/pages/downloadReport";
import Reservations from "./modules/restaurant/pages/tableManagement/pages/Reversations";
import OptionsListing from "./modules/restaurant/pages/menu/pages/OptionsListing";
import BulkImport from "./modules/restaurant/pages/settings/pages/bulkImport";
import ServiceCharge from "./modules/restaurant/pages/settings/pages/serviceCharge";
import ReceiptAndInvoice from "./modules/restaurant/pages/settings/pages/ReceiptInvoice";
import LoyaltyPoints from "./modules/restaurant/pages/settings/pages/LoyaltyPoints";
import PaymentMethod from "./modules/restaurant/pages/settings/pages/PaymentMethod";
import SelectTable from "./modules/restaurant/openPages/TableSelect";
import SalesReportStatusByDay from "./modules/restaurant/pages/sales/pages/SalesReportStatusByDay";
// import AbcAnalysisCategoryBasis from "./modules/restaurant/pages/sales/pages/AbcAnalysisCategoryBasis";
// import AbcAnalysisDayBasis from "./modules/restaurant/pages/sales/pages/AbcAnalysisDayBasis";
import SalesReportStatusByMonth from "./modules/restaurant/pages/sales/pages/SalesReportStatusByMonth";
import SalesReportStatusByWeek from "./modules/restaurant/pages/sales/pages/SalesReportStatusByWeek";
// import AbcAnalysis from "./modules/restaurant/pages/sales/pages/AbcAnalysis";
import ArrivalTime from "./modules/restaurant/pages/settings/pages/arrivalTime";
import PreDefineCurrencyValues from "./modules/restaurant/pages/settings/pages/addCurrencyValues";
import QRTableSelection from "./modules/qrOrder/pages/qaTableSelection";
import OrderList from "./modules/restaurant/pages/sales/pages/orderList";

const router = createBrowserRouter([

  {
    path: "/", element: <GlobalLayout />,
    children: [

      // {
      //   path: "/",
      //   element: <Navigate to={"/admin/dashboard"} />
      // },

      /** 404 page for website >>>>  */
      {
        path: "/",
        element: <WebsiteLayout />,
        children: [
          { path: "", element: <WebsiteHomePage /> },
          { path: "/about-us", element: <WebsiteAboutUs /> },
          { path: "/contact-us", element: <WebsiteContactUs /> },
          { path: "/privacy-policy", element: <WebsitePrivacyPolicy /> },
          { path: "/terms-conditions", element: <WebsiteTerms /> },
          { path: "/faq", element: <Faq /> },
          { path: "/inquiry", element: <WebsiteInquiry /> },
          { path: "/org-info/:slug", element: <DynamicWebPage /> },
          { path: "*", element: <Page404 /> },
        ],
      },
      /** 404 page for website <<<<  */

      /**ADMIN ROUTE START */
      {
        path: "admin",
        element: <PrivateRoute component={AdminLayout} />,
        children: [
          {
            path: "",
            element: <Navigate to={"/admin/dashboard"} />,
          },
          {
            path: "dashboard",
            element: <PrivateRoute component={Dashboard} />,
          },
          {
            path: "profile",
            // element: <Profile />,
            element: <PrivateRoute component={Profile} />,
            children: [
              {
                path: "edit/:id",
                // element: <EditProfile />,
                element: <PrivateRoute component={EditProfile} />,
              },
              {
                path: "change-password/:id",
                // element: <Changepassword />,
                element: <PrivateRoute component={Changepassword} />,
              },
            ],
          },

          {
            /**cafe management route start */
          },
          {
            path: "cafe-management/cafe/list/:pgno",
            // element: <UsersTable />,
            element: <PrivateRoute component={UsersTable} />,
          },
          {
            path: "cafe-management/cafe/list/:id/enroll-cafe/renew-plan",
            element: <PrivateRoute component={RenewEnrollPlan} />,
          },
          // {
          //   path: "cafe-management/cafe/view/:id",
          //   element: <PrivateRoute component={UsersView} />,
          // },
          {
            path: "cafe-management/cafe/view/",
            element: <PrivateRoute component={RestaurantView} />,

            children: [
              {
                path: ":id/generals",
                // element: <UsersView />
                element: <PrivateRoute component={UsersView} />,
              },
              {
                path: ":id/enroll-cafe/details/:pgno",
                // element: <ViewEnrollments />
                element: <PrivateRoute component={ViewEnrollments} />,
              },
              {
                path: ":id/enroll-cafe/renew-plan",
                element: <PrivateRoute component={RenewEnrollPlan} />,
              },
              {
                path: ":id/enroll-restaurant/edit",
                element: <PrivateRoute component={EditEnrollDetails} />,
              },
              {
                path: ":id/enroll-restaurant/view",
                element: <PrivateRoute component={ViewEnrollDetails} />,
              },
              {
                path: ":id/transition-details/:pgno",
                element: <PrivateRoute component={TransactionsTable} />,
              },
              {
                path: ":id/transition-details/view",
                element: <PrivateRoute component={ViewTransaction} />,
              },
            ],
          },

          {
            path: "cafe-management/cafe/add",
            element: <PrivateRoute component={UsersAdd} />,
          },
          {
            path: "cafe-management/cafe/:pgno/edit/:id",
            element: <PrivateRoute component={UserEdit} />,
          },
          {
            path: "/admin/cafe-management/cafe/enroll-cafe/:userId",
            element: <PrivateRoute component={EnrollRestaurant} />,
          },
          {
            /**cafe management route end */
          },

          {
            /**testimonial management route start */
          },
          {
            path: "testimonial-management/testimonial/list/:pgno",
            element: <TestimonialTable />,
          },
          {
            path: "testimonial-management/testimonial/view/:id",
            element: <TestimonialView />,
          },
          {
            path: "testimonial-management/testimonial/add",
            element: <TestimonialAdd />,
          },
          {
            path: "testimonial-management/testimonial/:pgno/edit/:id",
            element: <TestimonialEdit />,
          },
          {
            /**testimonial management route end */
          },

          {
            /**inquiries route start */
          },
          {
            path: "inquiries/list/:pgno",
            element: <PrivateRoute component={InquiryTable} />,
          },
          {
            path: "inquiries/view/:id",
            element: <PrivateRoute component={ViewInquiry} />,
          },
          {
            /**contact-us route start */
          },
          {
            path: "contact-us/list/:pgno",
            element: <PrivateRoute component={ContactUsTable} />,
          },
          {
            path: "contact-us/view/:id",
            element: <PrivateRoute component={ViewContactUs} />,
          },
          {
            /**contact-us route end */
          },
          {
            /**testimonial management route end */
          },

          {
            path: "cms/pages/list/:pgno",
            element: <PrivateRoute component={PageTable} />,
          },
          {
            path: "cms/pages/add",
            element: <PrivateRoute component={PageAdd} />,
          },
          {
            path: "cms/pages/:pgno/edit/:id",
            element: <PrivateRoute component={PageEdit} />,
          },
          {
            path: "cms/pages/view/:id",
            element: <PrivateRoute component={PageView} />,
          },

          {
            path: "cms/banner/list/:pgno",
            element: <PrivateRoute component={BannerTable} />,
          },
          {
            path: "cms/banner/add",
            element: <PrivateRoute component={BannerAdd} />,
          },
          {
            path: "cms/banner/:pgno/edit/:id",
            element: <PrivateRoute component={BannerEdit} />,
          },
          {
            path: "cms/banner/view/:id",
            element: <PrivateRoute component={BannerView} />,
          },

          {
            path: "cms/faq/list/:pgno",
            element: <PrivateRoute component={FAQTable} />,
          },
          {
            path: "cms/faq/add",
            element: <PrivateRoute component={FAQAdd} />,
          },
          {
            path: "cms/faq/:pgno/edit/:id",
            element: <PrivateRoute component={FAQEdit} />,
          },
          {
            path: "cms/faq/view/:id",
            element: <PrivateRoute component={FAQView} />,
          },

          {
            path: "cms/settings",
            element: <PrivateRoute component={GlobalSettings} />,
          },

          {
            path: "cms/default-email-template/list/:pgno",
            element: <PrivateRoute component={EmailTemplatesTable} />,
          },
          {
            path: "cms/default-email-template/add",
            element: <PrivateRoute component={EmailTempAdd} />,
          },
          {
            path: "cms/default-email-template/:pgno/edit/:id",
            element: <PrivateRoute component={EmailTempEdit} />,
          },
          {
            path: "cms/default-email-template/view/:id",
            element: <PrivateRoute component={ViewEmailTemp} />,
          },

          /** Email Logs Routing End*/
        ],
      },
      {
        path: "admin",
        element: <AdminUnAuthLayout />,
        children: [
          { path: "login", element: <PublicRoute component={Login} /> },
          {
            path: "forget-password",
            element: <PublicRoute component={ForgotPwdPage} />,
          },
          {
            path: "otp-verification/:email",
            element: <PublicRoute component={OtpVerificationPage} />,
          },
          {
            path: "reset-password",
            // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
            element: <PublicRoute component={ResetPwdPage} />,
          },
        ],
      },

      { path: "admin/*", element: <Error404 /> },
      /**ADMIN ROUTE END */

      { path: "*", element: <Page404 homePath="/" /> },
    ],

  },



  /** RESTAURANT ROUTE START */
  {
    path: "restaurant",
    element: <RestaurantPrivateRoute component={RestaurantLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/restaurant/dashboard"} />,
      },
      {
        path: "dashboard",
        element: <RestaurantPrivateRoute component={RestaurantHomeLayout} />,
        children: [
          {
            path: "",
            element: <RestaurantPrivateRoute component={RestDashboard} />,
          },
        ],
      },
      {
        path: "profile",
        element: (
          <RestaurantPrivateRoute component={RestaurantMyProfileLayout} />
        ),
        children: [
          {
            path: "",
            element: <RestaurantPrivateRoute component={RestMyProfile} />,
          },
          {
            path: "change-password",
            element: (
              <RestaurantPrivateRoute component={ProfileChangePassword} />
            ),
          },
          {
            path: "restaurant-profile",
            element: <RestaurantPrivateRoute component={RestaurantProfile} />,
          },
          {
            path: "contract-information",
            element: <RestaurantPrivateRoute component={ContractInformation} />
          },
          {
            path: "mail-notification-settings",
            element: <RestaurantPrivateRoute component={MailNotificationSettings} />
          },
          { path: "*", element: <Page404 homePath="/restaurant/profile" /> },
        ],
      },
      {
        path: "sales",
        element: <RestaurantPrivateRoute component={RestaurantSalesLayout} />,
        children:[
          {
            path: "",
            element: <RestaurantPrivateRoute component={SalesReportStatusByDay} /> 
          },
          {
            path: "sales-report-status-month",
            element: <RestaurantPrivateRoute component={SalesReportStatusByMonth} /> 
          },
          {
            path: "sales-report-status-week",
            element: <RestaurantPrivateRoute component={SalesReportStatusByWeek} /> 
          },
          {
            path: "order/:page",
            element: <RestaurantPrivateRoute component={OrderList} /> 
          },
          // {
          //   path: "abc-analysis",
          //   element: <RestaurantPrivateRoute component={AbcAnalysis} /> 
          // },
          // {
          //   path: "abc-analysis-category-basis",
          //   element: <RestaurantPrivateRoute component={AbcAnalysisCategoryBasis} /> 
          // },
          // {
          //   path: "abc-analysis-day-basis",
          //   element: <RestaurantPrivateRoute component={AbcAnalysisDayBasis} /> 
          // },
          {
            path: "sales-transaction-history/:page",
            element: <RestaurantPrivateRoute component={SalesTransactionHistory} /> 
          },
          // {
          //   path: "sales-slip-changes",
          //   element: <RestaurantPrivateRoute component={SalesSlipChanges} /> 
          // },
          // { path: "*", element: <Page404 homePath="/restaurant/sales" /> },
        ],
      },
      {
        path: "menu",
        element: <RestaurantPrivateRoute component={RestaurantMenuLayout} />,
        children:[
          {
            path: "",
            element: <CategoriesListing />,
          },
          {
            path:"menu-item/list",
            element: <MenuItemListing />,
          },
          {
            path:"menu-item/list/:id",
            element: <MenuItemListing />,
          },
          {
            path:"options/list/:active_option?",
            element: <OptionsListing />,
          },
          { path: "*", element: <Page404 homePath="/restaurant/menu" /> },
        ],
      },
      {
        path: "table-management",
        element: <RestaurantTableManagementLayout />,
        children: [
          {
            path: "table/:page",
            element: <Tables />,
          },
          {
            path: "reservations/list/:page",
            element: <Reservations />,
          },
          { path: "*", element: <Page404 homePath="/restaurant/table-management" /> },
        ],
      },
      {
        path: "settings",
        element: <RestaurantSettingsLayout />,
        children: [
          {
            path: "staff/:page",
            element: <Staff />,
          },
          {
            path: "Driver/:page",
            element: <Driver />,
          },
          {
            path: "staff-attendance/:page",
            element: <Staff />,
          },
          // {
          //   path: "coupon/:page",
          //   element: <Coupon />,
          // },
          {
            path: "receipt-invoice",
            element: <ReceiptAndInvoice />,
          },
          {
            path: "bulk-import",
            element: <BulkImport />,
          },
          {
            path: "loyalty-points/:page",
            element: <LoyaltyPoints />,
          },
          // {
          //   path: "receipt-invoice",
          //   element: <ReceiptAndInvoice />,
          // },
          // {
          //   path: "bulk-import",
          //   element: <BulkImport />,
          // },
          // {
          //   path: "tip",
          //   element: <Tip />,
          // },
          
          {
            path: "tip-configuration",
            element: <TipConfiguration />,
          },

          {
            path: "arrival-time",
            element: <ArrivalTime />,
          },

          {
            path: "pre-define-currency-values",
            element : <PreDefineCurrencyValues />
          },

          {
            path: "tax",
            element: <Tax />,
          },
          {
            path: "service-charges",
            element: <ServiceCharge />,
          },
          {
            path: "payment-method",
            element: <PaymentMethod/>,
          },
          // {
          //   path: "other-payment",
          //   element: <OtherPaymentMethod />,
          // },
          {
            path: "download-report",
            element: <DownloadReport />,
          },
          {
            path: "theme-customizer",
            element: <ThemeCustomizer />,
          },
          { path: "*", element: <Page404 homePath="/restaurant/settings" /> },
        ],
      },
      { path: "*", element: <Page404 homePath="/restaurant/dashboard" /> },
    ],
  },
  /** RESTAURANT ROUTE END */

  /** RESTAURANT AUTH ROUTE START */
  {
    path: "restaurant",
    element: <RestaurantPublicRoute component={RestaurantAuthLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/restaurant/dashboard"} />
      },
      // {
      //   path: "select-role",
      //   element: <RestaurantPublicRoute component={SelectUser} />
      // },
      {
        path: "login",
        element: <RestaurantPublicRoute component={RestaurantLogin} />,
      },
      {
        path: "forget-password",
        element: <RestaurantPublicRoute component={RestaurantForgotPwdPage} />,
      },
      {
        path: "reset-password",
        element: <RestaurantPublicRoute component={RestaurantResetPassword} />,
      },
      {
        path: "otp-verification",
        element: <RestaurantPublicRoute component={Verifyotp} />,
      },
      { path: "*", element: <Page404 homePath="/restaurant" /> },
    ],
  },

  /** STAFF ROUTE START */
  {
    path: "staff",
    element: <StaffLayout />,
    children: [
      {
        path: "",
        element: <Navigate to={"/staff/dashboard"} />,
      },
      {
        path: "dashboard",
        element: <StaffPrivateRoute component={StaffHomeLayout} />,
        children: [
          {
            path: "",
            element: <StaffPrivateRoute component={StaffPageDashboard} />,
          },
          { path: "*", element: <Page404 homePath="/staff/dashboard" /> }
        ],
      },
      { path: "*", element: <Page404 homePath="/staff" /> }
    ]
  },

    /** STAFF ROUTE END */

  {
    path: "qr-order",
    element: <QrOrderLayout />,
    children: [
      { path: "", element: <AddMenu /> },
      { path: "review", element: <ReviewOrder /> },
      { path: "place", element: <PlaceOrder /> },
      { path: "success", element: <OrderSuccess /> },
      { path: "table-select/:restaurant_id" , element : <QRTableSelection/> }
    ],
  },

  // open route for table selection from customer side
  {
    path : "select-table/:restaurant_id",
    element : <SelectTable/>
  }
]);

export default router;
